/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ score: NonNullable<unknown> }} Offerdetail_Reviews_Scoreoutof103Inputs */

const id_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const ms_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const da_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const de_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const en_us2_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const es_es2_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const es_mx2_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const fil_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const fr_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const it_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const hu_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const nl_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const no_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const pl_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const pt_br2_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score}/10`)
};

const pt_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const ro_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const fi_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const sv_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const vi_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const tr_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const cs_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const bg_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const ru_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const uk_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const ar_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const hi_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const th_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const ja_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const zh_cn2_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const zh_hant1_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

const ko_offerdetail_reviews_scoreoutof103 = /** @type {(inputs: Offerdetail_Reviews_Scoreoutof103Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} / 10`)
};

/**
* | output |
* | --- |
* | "{score} / 10" |
*
* @param {Offerdetail_Reviews_Scoreoutof103Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_scoreoutof103 = /** @type {((inputs: Offerdetail_Reviews_Scoreoutof103Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Scoreoutof103Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "da") return da_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "de") return de_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "it") return it_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "no") return no_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "th") return th_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_scoreoutof103(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_scoreoutof103(inputs)
	return ko_offerdetail_reviews_scoreoutof103(inputs)
});
export { offerdetail_reviews_scoreoutof103 as "offerDetail.reviews.scoreOutOf10" }